<p-toast></p-toast>

<div class="container" *ngIf="searched && data && data.length > 0; else noResultsFound">
  <div class="styled-text-wrapper">
    <span class="styled-text">{{ searchQueryGrid }}</span>
  </div>

  <div class="main-content" *ngFor="let item of data; let i = index">
    <div class="card" [ngClass]="{ expanded: expandedCards[i], collapsed: !expandedCards[i] }">
      <div *ngIf="i % 1 === 0" class="route-label-container">
        <div class="line"></div>
        <div class="route-label">
          DOCS
          {{
          currentPage_technical === 1
          ? i + 1
          : (currentPage_technical - 1) * (currentRow_technical || 15) +
          i +
          1
          }}
        </div>

        <div class="line"></div>
      </div>
      <section class="product-info" id="productinfo">
        <h4 style="
            font-weight: 800;
            font-size: 20px;
            color: #388e3c;
            margin-bottom: 50px;
            text-align: left;
            background: #ff5623;
            -webkit-background-clip: text;
            color: transparent;
            text-shadow: 2px 2px 5px rgba(0, 0, 0, 0.1),
              -2px -2px 5px rgba(0, 0, 0, 0.1);
            letter-spacing: 1px;
            transition: color 0.3s ease, text-shadow 0.3s ease;
          ">
          {{ item.activeIngredientBiologicsCombination }}
          <button class="copy-btn" *ngIf="item.activeIngredientBiologicsCombination"
            (click)="copyToClipboard(item.activeIngredientBiologicsCombination)" pTooltip="Copy to clipboard"
            tooltipPosition="top">
            <i class="pi pi-copy"></i>
          </button>
        </h4>
        <!-- Chemical Structure Image -->
        <!-- <div class="product-container2">
          Left Side: Chemical Structure
          <div class="chemical-structure2" *ngIf="item.routeOfSynthesis">
            <h2>Chemical Structure</h2>
            <div class="image-container2">
              <img
                class="inventor-logo"
                *ngIf="item.routeOfSynthesis"
                [src]="
                  'https://www.chemrobotics.com/agropat/images/route_of_synthesis/' +
                  item.routeOfSynthesis
                "
                alt="Inventor Logo"
              />
            </div>
            <button class="view-btn2" (click)="openGalleria(item)">
              <i class="pi pi-search"></i>
            </button>
          </div>

          Right Side: Product Information
          <div class="product-info-container2">
            <div class="product-info2" *ngIf="item.gbrn">
              <h6>
                GBRN
                <button
                  class="copy-btn2"
                  (click)="copyToClipboardFormattedDate(item.gbrn)"
                  pTooltip="Copy to clipboard"
                  tooltipPosition="top"
                >
                  <i class="pi pi-copy"></i>
                </button>
              </h6>

              {{ item.gbrn }}
            </div>
            <div class="product-info2" *ngIf="item.trrn">
              <h6>
                TRRN
                <button
                  class="copy-btn2"
                  (click)="copyToClipboard(item.trrn)"
                  pTooltip="Copy to clipboard"
                  tooltipPosition="top"
                >
                  <i class="pi pi-copy"></i>
                </button>
              </h6>

              <p>
                {{ item.trrn || "-" }}
              </p>
            </div>
            <div class="product-info2" *ngIf="item.activeIngredient">
              <h6>
                ACTIVE INGREDIENT
                <button
                  class="copy-btn2"
                  *ngIf="item.activeIngredient"
                  (click)="copyToClipboard(item.activeIngredient)"
                  pTooltip="Copy to clipboard"
                  tooltipPosition="top"
                >
                  <i class="pi pi-copy"></i>
                </button>
              </h6>
              <p>
                {{ item.activeIngredient || "-" }}
              </p>
            </div>
            <div class="product-info2" *ngIf="item.activeIngredientCasRn">
              <h6>
                CAS RN
                <button
                  class="copy-btn2"
                  *ngIf="item.activeIngredientCasRn"
                  (click)="copyToClipboard(item.activeIngredientCasRn)"
                  pTooltip="Copy to clipboard"
                  tooltipPosition="top"
                >
                  <i class="pi pi-copy"></i>
                </button>
              </h6>
              <p>
                {{ item.activeIngredientCasRn || "-" }}
              </p>
            </div>
            <div class="product-info2" *ngIf="item.fieldOfApplication">
              <h6>
                FIELD OF APPLICATION
                <button
                  class="copy-btn2"
                  *ngIf="item.fieldOfApplication"
                  (click)="copyToClipboard(item.fieldOfApplication)"
                  pTooltip="Copy to clipboard"
                  tooltipPosition="top"
                >
                  <i class="pi pi-copy"></i>
                </button>
              </h6>

              <p>
                {{ item.fieldOfApplication || "-" }}
              </p>
            </div>
            <div class="product-info2" *ngIf="item.companyName">
              <h6>
                COMPANY NAME
                <button
                  class="copy-btn2"
                  *ngIf="item.companyName"
                  (click)="copyToClipboard(item.companyName)"
                  pTooltip="Copy to clipboard"
                  tooltipPosition="top"
                >
                  <i class="pi pi-copy"></i>
                </button>
              </h6>

              <p>{{ item.companyName || "-" }}</p>
              <div class="logos-images">
                <img
                  style="width: 100px"
                  *ngIf="item.companyLogo; else placeholder"
                  [src]="
                    'https://www.chemrobotics.com/agropat/images/innovators_logo/' +
                    item.companyLogo
                  "
                  alt="Inventor Logo"
                  class="inventor-logo"
                  (error)="onImageError($event)"
                />
                <ng-template #placeholder>
                  <span style="width: 300px; display: inline-block"
                    >INVENTOR LOGO</span
                  >
                </ng-template>
              </div>
            </div>
          </div>
        </div> -->

        <!-- Bootstrap Modal for Full Image View -->
        <p-galleria [value]="galleriaImages" [(visible)]="displayGalleria" [containerStyle]="{ 'max-width': '100%' }"
          [numVisible]="1" [circular]="true" [fullScreen]="true" [showItemNavigators]="false" [showThumbnails]="false">
          <ng-template pTemplate="item" let-item>
            <!-- Modal Background (Click to Close) -->
            <div class="modal-overlay" (click)="closeGalleria($event)">
              <div class="image-wrapper" (click)="$event.stopPropagation()">
                <!-- Zoom Controls Positioned at the Top Right -->
                <div class="zoom-controls">
                  <button (click)="zoomIn($event)" title="Zoom In">
                    <i class="pi pi-search-plus"></i>
                  </button>
                  <button (click)="zoomOut($event)" title="Zoom Out">
                    <i class="pi pi-search-minus"></i>
                  </button>
                  <button class="close-button" (click)="closeGalleria($event)">
                    ×
                  </button>
                </div>

                <!-- Scrollable Image Container -->
                <div class="zoom-container">
                  <img [src]="item.itemImageSrc" [style.transform]="'scale(' + zoomLevel + ')'"
                    class="zoomable-image" />
                </div>
              </div>
            </div>
          </ng-template>
        </p-galleria>

        <div class="logos" id="contentToExport3">
          <!-- <h3 class="logos-title">Innovators' Logos</h3> -->
          <!-- Title remains above images -->
          <!-- inventorLogo -->

          <!-- <div class="result-header">
      <h6 style="margin-top: 8px">
        {{ item.companyLogo || "-" }}
      </h6>
    </div> -->
        </div>

        <div class="product-detail" id="contentToExport1">
          <div class="grid grid-cols-3" style="margin-top: -20px">
            <div class="product-info2" *ngIf="
                displayMap['chemrobotics_document_registrationNumber_cdrn'] &&
                item.chemrobotics_document_registrationNumber_cdrn
              ">
              <h6>
                chemrobotics document registration number cdrn
                <button class="copy-btn2" (click)="
                    copyToClipboard(
                      item.chemrobotics_document_registrationNumber_cdrn
                    )
                  ">
                  <i class="pi pi-copy"></i>
                </button>
              </h6>
              <p>
                {{ item.chemrobotics_document_registrationNumber_cdrn || "-" }}
              </p>
            </div>

            <div class="product-info2" *ngIf="displayMap['tradeName'] && item.tradeName">
              <h6>
                trade name

                <button class="copy-btn" *ngIf="item.tradeName" (click)="copyToClipboard(item.tradeName)"
                  pTooltip="Copy to clipboard" tooltipPosition="top">
                  <i class="pi pi-copy"></i>
                </button>
              </h6>
              <p>
                {{ item.tradeName || "-" }}
              </p>
            </div>
            <div class="product-info2" *ngIf="displayMap['nameOfDocuments'] && item.nameOfDocuments">
              <h6>
                NAME OF DOCUMENT(S)(LABEL / FACT SHEET / MONOGRAPH / SDS /
                CERTIFICATE / DFU / OTHERS)

                <button class="copy-btn" *ngIf="item.nameOfDocuments" (click)="copyToClipboard(item.nameOfDocuments)"
                  pTooltip="Copy to clipboard" tooltipPosition="top">
                  <i class="pi pi-copy"></i>
                </button>
              </h6>
              <p>
                {{ item.nameOfDocuments || "-" }}
              </p>
            </div>
            <!-- <div class="logos-images" *ngIf="item.country">
              <img
                style="width: 100px"
                *ngIf="item.country"
                [src]="
                  'https://www.chemrobotics.com/agropat/images/innovators_logo/' +
                  item.country
                "
                alt="Inventor Logo"
                class="inventor-logo"
                (error)="onImageError($event)"
              />
              <ng-template #placeholder>
                <span style="width: 300px; display: inline-block"
                  >INVENTOR LOGO</span
                >
              </ng-template>
            </div> -->

            <div class="product-info2" *ngIf="displayMap['fieldOfDocument'] && item.fieldOfDocument">
              <h6>
                FIELD OF DOCUMENT(AGROCHEMICAL / PHARMACEUTICAL / AYURVEDIC /
                VETERINARY / HOMEOPATHIC )

                <button class="copy-btn2" (click)="copyToClipboard(item.fieldOfDocument)">
                  <i class="pi pi-copy"></i>
                </button>
              </h6>
              <p>{{ item.fieldOfDocument || "-" }}</p>
            </div>

            <!-- <div class="product-info2" *ngIf="item.patentType">
              <h6>
                PATENT OR NON-PATENT TYPE
                <button
                  class="copy-btn2"
                  (click)="copyToClipboard(item.patentType)"
                >
                  <i class="pi pi-copy"></i>
                </button>
              </h6>
              <p>{{ item.patentType || "-" }}</p>
            </div> -->

            <div class="product-info2" *ngIf="
                displayMap['patentNonPatentReferences'] &&
                item.patentNonPatentReferences
              ">
              <h6>
                PATENT OR NON-PATENT REFERENCE (S)

                <button class="copy-btn2" (click)="copyToClipboard(item.patentNonPatentReferences)">
                  <i class="pi pi-copy"></i>
                </button>
              </h6>
              <p>{{ item.patentNonPatentReferences || "-" }}</p>
            </div>
            <!-- <div class="logos-images" *ngIf="item.defendantLogo">
              <img
                style="width: 100px"
                *ngIf="item.defendantLogo"
                [src]="
                  'https://www.chemrobotics.com/agropat/images/innovators_logo/' +
                  item.defendantLogo
                "
                alt="Inventor Logo"
                class="inventor-logo"
                (error)="onImageError($event)"
              />
              <ng-template #placeholder>
                <span style="width: 300px; display: inline-block"
                  >INVENTOR LOGO</span
                >
              </ng-template>
            </div> -->
            <div class="product-info2" *ngIf="displayMap['productType'] && item.productType">
              <h6>
                PRODUCT TYPE (SOLO / COMBINATION / ADMIXTURE / SOLVENT /
                INTERMEDIATE)

                <button class="copy-btn" *ngIf="item.productType" (click)="copyToClipboard(item.productType)"
                  pTooltip="Copy to clipboard" tooltipPosition="top">
                  <i class="pi pi-copy"></i>
                </button>
              </h6>

              <p>
                {{ item.productType || "-" }}
              </p>
            </div>
            <div class="product-info2" *ngIf="displayMap['typeOfCombination'] && item.typeOfCombination">
              <h6>
                TYPE OF COMBINATION (2 / 3 /4 /5 WAY MIXTURE)

                <button class="copy-btn" *ngIf="item.typeOfCombination"
                  (click)="copyToClipboard(item.typeOfCombination)" pTooltip="Copy to clipboard" tooltipPosition="top">
                  <i class="pi pi-copy"></i>
                </button>
              </h6>

              <p>
                {{ item.typeOfCombination || "-" }}
              </p>
            </div>
            <div class="product-info2" *ngIf="displayMap['country'] && item.country">
              <h6>
                COUNTRY

                <button class="copy-btn" *ngIf="item.country" (click)="copyToClipboard(item.country)"
                  pTooltip="Copy to clipboard" tooltipPosition="top">
                  <i class="pi pi-copy"></i>
                </button>
              </h6>

              <p>
                {{ item.country || "-" }}
              </p>
            </div>
            <div class="product-info2" *ngIf="displayMap['documents'] && item.documents">
              <h6>
                DOCUMENTS (.PDF / .DOC)
                <button class="copy-btn" *ngIf="item.documents" (click)="copyToClipboard(item.documents)"
                  pTooltip="Copy to clipboard" tooltipPosition="top">
                  <i class="pi pi-copy"></i>
                </button>
              </h6>

              <a style="
                  margin: 5px;
                  padding: 10px;
                  background: #ff5623;
                  color: rgb(255 237 141);
                  text-decoration: none;
                  border-radius: 5px;
                  cursor: pointer;
                  display: inline-block;
                " target="_blank" [href]="
                  'https://www.chemrobotics.com/agropat/pdf/gsda/docs/' +
                  item.documents
                ">
                {{ item.nameOfDocuments || "-" }}
              </a>
            </div>
            <div class="product-info2" *ngIf="
                displayMap['applicantsCompaniesInstitutes'] &&
                item.applicantsCompaniesInstitutes
              ">
              <h6>
                APPLICANT (S) / COMPANY (S) / INSTITUTE (S)

                <button class="copy-btn" *ngIf="item.applicantsCompaniesInstitutes"
                  (click)="copyToClipboard(item.applicantsCompaniesInstitutes)" pTooltip="Copy to clipboard"
                  tooltipPosition="top">
                  <i class="pi pi-copy"></i>
                </button>
              </h6>

              <p>
                {{ item.applicantsCompaniesInstitutes || "-" }}
              </p>
            </div>
            <div class="product-info2" *ngIf="displayMap['pubchemId'] && item.pubchemId">
              <h6>
                PUBCHEM CID:
                <button class="copy-btn" *ngIf="item.pubchemId" (click)="copyToClipboard(item.pubchemId)"
                  pTooltip="Copy to clipboard" tooltipPosition="top">
                  <i class="pi pi-copy"></i>
                </button>
              </h6>

              <a style="
                  margin: 5px;
                  padding: 10px;
                  background: #ff5623;
                  color: rgb(255 237 141);
                  text-decoration: none;
                  border-radius: 5px;
                  cursor: pointer;
                  display: inline-block;
                " target="_blank" [href]="
                  'https://pubchem.ncbi.nlm.nih.gov/compound/' + item.pubchemId
                ">
                {{ item.pubchemId || "-" }}
              </a>
            </div>

            <div class="product-info2" *ngIf="displayMap['chemicalClass'] && item.chemicalClass">
              <h6>
                chemicalClass

                <button class="copy-btn" *ngIf="item.chemicalClass" (click)="copyToClipboard(item.chemicalClass)"
                  pTooltip="Copy to clipboard" tooltipPosition="top">
                  <i class="pi pi-copy"></i>
                </button>
              </h6>

              <p>
                {{ item.chemicalClass || "-" }}
              </p>
            </div>
            <div class="product-info2" *ngIf="displayMap['indication'] && item.indication">
              <h6>
                indication

                <button class="copy-btn" *ngIf="item.indication" (click)="copyToClipboard(item.indication)"
                  pTooltip="Copy to clipboard" tooltipPosition="top">
                  <i class="pi pi-copy"></i>
                </button>
              </h6>

              <p>
                {{ item.indication || "-" }}
              </p>
            </div>
            <div class="product-info2" *ngIf="displayMap['tradeName'] && item.tradeName">
              <h6>
                trade name

                <button class="copy-btn" *ngIf="item.tradeName" (click)="copyToClipboard(item.tradeName)"
                  pTooltip="Copy to clipboard" tooltipPosition="top">
                  <i class="pi pi-copy"></i>
                </button>
              </h6>

              <p>
                {{ item.tradeName || "-" }}
              </p>
            </div>
            <div class="product-info2" *ngIf="displayMap['typeOfDocument'] && item.typeOfDocument">
              <h6>
                type of document

                <button class="copy-btn" *ngIf="item.typeOfDocument" (click)="copyToClipboard(item.typeOfDocument)"
                  pTooltip="Copy to clipboard" tooltipPosition="top">
                  <i class="pi pi-copy"></i>
                </button>
              </h6>

              <p>
                {{ item.typeOfDocument || "-" }}
              </p>
            </div>
            <div class="product-info2" *ngIf="
                displayMap['noticeNumberDocumentNumberCertificateNumber'] &&
                item.noticeNumberDocumentNumberCertificateNumber
              ">
              <h6>
                notice number document number certificate number
                <button class="copy-btn" *ngIf="item.noticeNumberDocumentNumberCertificateNumber" (click)="
                    copyToClipboard(
                      item.noticeNumberDocumentNumberCertificateNumber
                    )
                  " pTooltip="Copy to clipboard" tooltipPosition="top">
                  <i class="pi pi-copy"></i>
                </button>
              </h6>

              <p>
                {{ item.noticeNumberDocumentNumberCertificateNumber || "-" }}
              </p>
            </div>
            <div class="product-info2" *ngIf="
                displayMap[
                  'patentPublicationNumberApplicationNumberPatentDocumentNumber'
                ] &&
                item.patentPublicationNumberApplicationNumberPatentDocumentNumber
              ">
              <h6>
                patent publication number application number patent document
                number

                <button class="copy-btn" *ngIf="
                    item.patentPublicationNumberApplicationNumberPatentDocumentNumber
                  " (click)="
                    copyToClipboard(
                      item.patentPublicationNumberApplicationNumberPatentDocumentNumber
                    )
                  " pTooltip="Copy to clipboard" tooltipPosition="top">
                  <i class="pi pi-copy"></i>
                </button>
              </h6>

              <p>
                {{
                item.patentPublicationNumberApplicationNumberPatentDocumentNumber ||
                "-"
                }}
              </p>
            </div>
            <div class="product-info2" *ngIf="displayMap['province'] && item.province">
              <h6>
                province

                <button class="copy-btn" *ngIf="item.province" (click)="copyToClipboard(item.province)"
                  pTooltip="Copy to clipboard" tooltipPosition="top">
                  <i class="pi pi-copy"></i>
                </button>
              </h6>

              <p>
                {{ item.province || "-" }}
              </p>
            </div>
            <div class="product-info2" *ngIf="
                displayMap['registrationNumber'] && item.registrationNumber
              ">
              <h6>
                registration number

                <button class="copy-btn" *ngIf="item.registrationNumber"
                  (click)="copyToClipboard(item.registrationNumber)" pTooltip="Copy to clipboard" tooltipPosition="top">
                  <i class="pi pi-copy"></i>
                </button>
              </h6>

              <p>
                {{ item.registrationNumber || "-" }}
              </p>
            </div>
            <div class="product-info2" *ngIf="displayMap['abstract'] && item.abstract">
              <h6>
                abstract

                <button class="copy-btn" *ngIf="item.abstract" (click)="copyToClipboard(item.abstract)"
                  pTooltip="Copy to clipboard" tooltipPosition="top">
                  <i class="pi pi-copy"></i>
                </button>
              </h6>

              <p>
                {{ item.abstract || "-" }}
              </p>
            </div>
            <div class="product-info2" *ngIf="displayMap['description'] && item.description">
              <h6>
                description

                <button class="copy-btn" *ngIf="item.description" (click)="copyToClipboard(item.description)"
                  pTooltip="Copy to clipboard" tooltipPosition="top">
                  <i class="pi pi-copy"></i>
                </button>
              </h6>

              <p>
                {{ item.description || "-" }}
              </p>
            </div>
            <div class="product-info2" *ngIf="displayMap['inventorsAuthors'] && item.inventorsAuthors">
              <h6>
                inventors authors

                <button class="copy-btn" *ngIf="item.inventorsAuthors" (click)="copyToClipboard(item.inventorsAuthors)"
                  pTooltip="Copy to clipboard" tooltipPosition="top">
                  <i class="pi pi-copy"></i>
                </button>
              </h6>

              <p>
                {{ item.inventorsAuthors || "-" }}
              </p>
            </div>
            <div class="product-info2" *ngIf="
                displayMap['documentCreationDate'] && item.documentCreationDate
              ">
              <h6>
                document creation date
                <button class="copy-btn" *ngIf="item.documentCreationDate"
                  (click)="copyToClipboard(item.documentCreationDate)" pTooltip="Copy to clipboard"
                  tooltipPosition="top">
                  <i class="pi pi-copy"></i>
                </button>
              </h6>

              <p>
                {{ item.documentCreationDate || "-" }}
              </p>
            </div>
            <div class="product-info2" *ngIf="
                displayMap['document_publicationDate'] &&
                item.document_publicationDate
              ">
              <h6>
                document publication date
                <button class="copy-btn" *ngIf="item.document_publicationDate"
                  (click)="copyToClipboard(item.document_publicationDate)" pTooltip="Copy to clipboard"
                  tooltipPosition="top">
                  <i class="pi pi-copy"></i>
                </button>
              </h6>

              <p>
                {{ item.document_publicationDate || "-" }}
              </p>
            </div>
            <div class="product-info2" *ngIf="
                displayMap['uniformResourceLocatorUrl'] &&
                item.uniformResourceLocatorUrl
              ">
              <h6>
                uniform resource locator url
                <button class="copy-btn" *ngIf="item.uniformResourceLocatorUrl"
                  (click)="copyToClipboard(item.uniformResourceLocatorUrl)" pTooltip="Copy to clipboard"
                  tooltipPosition="top">
                  <i class="pi pi-copy"></i>
                </button>
              </h6>

              <p>
                {{ item.uniformResourceLocatorUrl || "-" }}
              </p>
            </div>
            <div class="product-info2" *ngIf="
                displayMap['digitalObjectIdentifierDoi'] &&
                item.digitalObjectIdentifierDoi
              ">
              <h6>
                digital object identifier doi
                <button class="copy-btn" *ngIf="item.digitalObjectIdentifierDoi"
                  (click)="copyToClipboard(item.digitalObjectIdentifierDoi)" pTooltip="Copy to clipboard"
                  tooltipPosition="top">
                  <i class="pi pi-copy"></i>
                </button>
              </h6>

              <p>
                {{ item.digitalObjectIdentifierDoi || "-" }}
              </p>
            </div>
            <div class="product-info2" *ngIf="
                displayMap['internationalStandardSerialNumberIssn'] &&
                item.internationalStandardSerialNumberIssn
              ">
              <h6>
                international standard serial number issn
                <button class="copy-btn" *ngIf="item.internationalStandardSerialNumberIssn" (click)="
                    copyToClipboard(item.internationalStandardSerialNumberIssn)
                  " pTooltip="Copy to clipboard" tooltipPosition="top">
                  <i class="pi pi-copy"></i>
                </button>
              </h6>

              <p>
                {{ item.internationalStandardSerialNumberIssn || "-" }}
              </p>
            </div>
            <div class="product-info2" *ngIf="displayMap['references'] && item.references">
              <h6>
                references
                <button class="copy-btn" *ngIf="item.references" (click)="copyToClipboard(item.references)"
                  pTooltip="Copy to clipboard" tooltipPosition="top">
                  <i class="pi pi-copy"></i>
                </button>
              </h6>

              <p>
                {{ item.references || "-" }}
              </p>
            </div>

            <div class="product-info2" *ngIf="displayMap['notes'] && item.notes">
              <h6>
                notes
                <button class="copy-btn" *ngIf="item.notes" (click)="copyToClipboard(item.notes)"
                  pTooltip="Copy to clipboard" tooltipPosition="top">
                  <i class="pi pi-copy"></i>
                </button>
              </h6>

              <p>
                {{ item.notes || "-" }}
              </p>
            </div>
            <div class="product-info2" *ngIf="displayMap['comment'] && item.comment">
              <h6>
                comment
                <button class="copy-btn" *ngIf="item.comment" (click)="copyToClipboard(item.comment)"
                  pTooltip="Copy to clipboard" tooltipPosition="top">
                  <i class="pi pi-copy"></i>
                </button>
              </h6>

              <p>
                {{ item.comment || "-" }}
              </p>
            </div>

            <div class="product-info2" *ngIf="displayMap['miscellaneous'] && item.miscellaneous">
              <h6>
                miscellaneous
                <button class="copy-btn" *ngIf="item.miscellaneous" (click)="copyToClipboard(item.miscellaneous)"
                  pTooltip="Copy to clipboard" tooltipPosition="top">
                  <i class="pi pi-copy"></i>
                </button>
              </h6>

              <p>
                {{ item.miscellaneous || "-" }}
              </p>
            </div>

            <div class="product-info2" *ngIf="displayMap['remarks'] && item.remarks">
              <h6>
                remarks
                <button class="copy-btn" *ngIf="item.remarks" (click)="copyToClipboard(item.remarks)"
                  pTooltip="Copy to clipboard" tooltipPosition="top">
                  <i class="pi pi-copy"></i>
                </button>
              </h6>

              <p>
                {{ item.remarks || "-" }}
              </p>
            </div>
          </div>
        </div>
        <br />

        <!-- Additional Product Details -->
        <div class="product-additional-details">
          <div *ngIf="
              item.dummy1 ||
              item.dummy2 ||
              item.dummy3 ||
              item.dummy4 ||
              item.dummy5 ||
              item.dummy6 ||
              item.dummy7 ||
              item.dummy8 ||
              item.dummy9 ||
              item.dummy10 ||
              item.dummy11 ||
              item.dummy12 ||
              item.dummy13 ||
              item.dummy14
            " class="section-wrapper" id="dummy">
            <hr class="section-divider" />
            <h2 class="section-title">DUMMY</h2>
            <div class="product-details" style="margin-top: 20px">
              <div class="grid grid-cols-2 gap-2">
                <div *ngIf="displayMap['dummy1'] && item.dummy1" class="product-info">
                  <h6>
                    DUMMY 1
                    <button class="copy-btn" *ngIf="item.dummy1" (click)="copyToClipboard(item.dummy1)"
                      pTooltip="Copy to clipboard" tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>

                  <p>
                    {{ item.dummy1 }}
                  </p>
                  <!-- <p [innerHTML]="transformNewLines(item.dummy1 || '-')"></p> -->
                </div>

                <div *ngIf="displayMap['dummy2'] && item.dummy2" class="product-info">
                  <h6>
                    DUMMY 2
                    <button class="copy-btn" *ngIf="item.dummy2" (click)="copyToClipboard(item.dummy2)"
                      pTooltip="Copy to clipboard" tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>

                  <p>
                    {{ item.dummy2 }}
                  </p>
                  <!-- <p [innerHTML]="transformNewLines(item.dummy2 || '-')"></p> -->
                </div>
                <div *ngIf="displayMap['dummy3'] && item.dummy3" class="product-info">
                  <h6>
                    DUMMY 3
                    <button class="copy-btn" *ngIf="item.dummy3" (click)="copyToClipboard(item.dummy3)"
                      pTooltip="Copy to clipboard" tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>
                  <p>
                    {{ item.dummy3 }}
                  </p>
                  <!-- <p [innerHTML]="transformNewLines(item.dummy3 || '-')"></p> -->
                </div>
                <div *ngIf="displayMap['dummy4'] && item.dummy4" class="product-info">
                  <h6>
                    DUMMY 4
                    <button class="copy-btn" *ngIf="item.dummy4" (click)="copyToClipboard(item.dummy4)"
                      pTooltip="Copy to clipboard" tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>

                  <p>
                    {{ item.dummy4 }}
                  </p>
                  <!-- <p [innerHTML]="transformNewLines(item.dummy4 || '-')"></p> -->
                </div>
                <div *ngIf="displayMap['dummy5'] && item.dummy5" class="product-info">
                  <h6>
                    DUMMY 5
                    <button class="copy-btn" *ngIf="item.dummy5" (click)="copyToClipboard(item.dummy5)"
                      pTooltip="Copy to clipboard" tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>
                  <p>
                    {{ item.dummy5 }}
                  </p>
                  <!-- <p [innerHTML]="transformNewLines(item.dummy5 || '-')"></p> -->
                </div>
                <div *ngIf="displayMap['dummy6'] && item.dummy6" class="product-info">
                  <h6>
                    DUMMY 6
                    <button class="copy-btn" *ngIf="item.dummy6" (click)="copyToClipboard(item.dummy6)"
                      pTooltip="Copy to clipboard" tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>
                  <p>
                    {{ item.dummy6 }}
                  </p>
                  <!-- <p [innerHTML]="transformNewLines(item.dummy6 || '-')"></p> -->
                </div>
                <div *ngIf="displayMap['dummy7'] && item.dummy7" class="product-info">
                  <h6>
                    DUMMY 7
                    <button class="copy-btn" *ngIf="item.dummy7" (click)="copyToClipboard(item.dummy7)"
                      pTooltip="Copy to clipboard" tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>

                  <p>
                    {{ item.dummy7 }}
                  </p>
                  <!-- <p [innerHTML]="transformNewLines(item.dummy7 || '-')"></p> -->
                </div>
                <div *ngIf="displayMap['dummy8'] && item.dummy8" class="product-info">
                  <h6>
                    DUMMY 8
                    <button class="copy-btn" *ngIf="item.dummy1" (click)="copyToClipboard(item.dummy1)"
                      pTooltip="Copy to clipboard" tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>
                  <p>
                    {{ item.dummy8 }}
                  </p>
                  <!-- <p [innerHTML]="transformNewLines(item.dummy8 || '-')"></p> -->
                </div>
                <div *ngIf="displayMap['dummy9'] && item.dummy9" class="product-info">
                  <h6>
                    DUMMY 9
                    <button class="copy-btn" *ngIf="item.dummy9" (click)="copyToClipboard(item.dummy9)"
                      pTooltip="Copy to clipboard" tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>
                  <p>
                    {{ item.dummy9 }}
                  </p>
                  <!-- <p [innerHTML]="transformNewLines(item.dummy9 || '-')"></p> -->
                </div>
                <div *ngIf="displayMap['dummy10'] && item.dummy10" class="product-info">
                  <h6>
                    DUMMY 10
                    <button class="copy-btn" *ngIf="item.dummy10" (click)="copyToClipboard(item.dummy10)"
                      pTooltip="Copy to clipboard" tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>

                  <p>
                    {{ item.dummy10 }}
                  </p>
                  <!-- <p [innerHTML]="transformNewLines(item.dummy10 || '-')"></p> -->
                </div>
                <div *ngIf="displayMap['dummy11'] && item.dummy11" class="product-info">
                  <h6>
                    DUMMY 11
                    <button class="copy-btn" *ngIf="item.dummy11" (click)="copyToClipboard(item.dummy11)"
                      pTooltip="Copy to clipboard" tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>

                  <p>
                    {{ item.dummy11 }}
                  </p>
                  <!-- <p [innerHTML]="transformNewLines(item.dummy11 || '-')"></p> -->
                </div>
                <div *ngIf="displayMap['dummy12'] && item.dummy12" class="product-info">
                  <h6>
                    DUMMY 12
                    <button class="copy-btn" *ngIf="item.dummy12" (click)="copyToClipboard(item.dummy12)"
                      pTooltip="Copy to clipboard" tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>
                  <p>
                    {{ item.dummy12 }}
                  </p>
                  <!-- <p [innerHTML]="transformNewLines(item.dummy12 || '-')"></p> -->
                </div>
                <div *ngIf="displayMap['dummy13'] && item.dummy13" class="product-info">
                  <h6>
                    DUMMY 13
                    <button class="copy-btn" *ngIf="item.dummy13" (click)="copyToClipboard(item.dummy13)"
                      pTooltip="Copy to clipboard" tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>
                  <p>
                    {{ item.dummy13 }}
                  </p>
                  <!-- <p [innerHTML]="transformNewLines(item.dummy13 || '-')"></p> -->
                </div>
                <div *ngIf="displayMap['dummy14'] && item.dummy14" class="product-info">
                  <h6>
                    DUMMY 14
                    <button class="copy-btn" *ngIf="item.dummy14" (click)="copyToClipboard(item.dummy14)"
                      pTooltip="Copy to clipboard" tooltipPosition="top">
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>
                  <p>
                    {{ item.dummy14 }}
                  </p>
                  <!-- <p [innerHTML]="transformNewLines(item.dummy14 || '-')"></p> -->
                </div>
              </div>
            </div>

            <button class="view-more"></button>
          </div>
        </div>
      </section>
      <button class="read-more-btn" *ngIf="hasExpandableContent(item)" (click)="toggleCard(i)">
        {{ expandedCards[i] ? "Read Less" : "Read More" }}
      </button>
    </div>

    <!-- Sidebar -->
    <aside class="sidebar" *ngIf="i == 0">
      <div style="
          display: flex;
          width: 100%;
          align-items: center;
          justify-content: space-between;
        ">
        <!-- Left side: Total Records -->
        <div style="width: 50%">
          <strong style="
              background: #e84d1f;
              color: #ffed8d;
              font-size: 16px;
              font-weight: 700;
              padding: 11px 15px;
              border-radius: 12px;
              box-shadow: 0 2px 4px #0003;
              white-space: nowrap;
              display: block;
              width: fit-content;
            ">
            Total Records: {{ totalRecords }}
          </strong>
        </div>

        <!-- Right side: Buttons -->
        <div style="
            width: 50%;
            display: flex;
            justify-content: flex-end;
            margin-left: 50px;
          ">
          <button style="
              background-color: #ffcd04;
              padding: 8px;
              border: none;
              border-radius: 6px;
              cursor: pointer;
              margin-right: 10px;
            " (click)="exportExcel('csv')">
            <img src="../../../../assets/icons/download.png" />
            <span style="font-size: 12px; color: #000">CSV</span>
          </button>
          <button style="
              background-color: #ffcd04;
              padding: 8px;
              border: none;
              border-radius: 6px;
              cursor: pointer;
            " (click)="exportExcel('xlsx')">
            <img src="../../../../assets/icons/download.png" />
            <span style="font-size: 12px; color: #000">XLS</span>
          </button>
        </div>
      </div>

      <h3 class="sidebar-title">
        Filters
        <button class="sidebar-toggle" (click)="toggleSidebar()">
          <span *ngIf="!isSidebarOpen">☰</span>
          <span *ngIf="isSidebarOpen">×</span>
        </button>
      </h3>

      <ul [class.active]="isSidebarOpen">
        <li>
          <label for="categoryFilter">NAME OF DOCUMENT</label>
          <p-dropdown [options]="documentOptions" [filter]="true" filterPlaceholder="Search NAME OF DOCUMENT"
            class="w-full custom-dropdown" [(ngModel)]="currentFliter.nameOfDocuments"
            (onChange)="createFilter('documents', $event.value)" placeholder="Select NAME OF DOCUMENT"></p-dropdown>
        </li>
      </ul>
      <div class="filter-buttons">
        <button (click)="applyFilter()">Apply Filter</button>
        <button (click)="resetFilter()">Reset Filter</button>
      </div>
    </aside>
  </div>

  <div class="pagination-container">
    <p-paginator (onPageChange)="onPageChange($event)" [first]="first" [rows]="rows" [totalRecords]="totalRecords"
      [styleClass]="'custom-paginator'">
    </p-paginator>

    <p class="total-pages" *ngIf="totalpages > 2">
      Total Pages: <span>{{ totalpages }}</span>
    </p>
  </div>
  <button class="back_to_top my-5" (click)="scrollToTop()">
    <img class="back_to_top_img" src="../../../assets/icons/output-onlinepngtools (5).png" />
  </button>
</div>
<ng-template #noResultsFound>
  <div class="no-results-container" *ngIf="searched">
    <img src="../../../assets/img/no-data.png" class="no-results-image" alt="No data available" />
    <div class="no-results-message color_black">
      <span class="font_20 weight_800">Sorry – The search found zero results. Why…</span>
      <ul class="no-results-list text_start">
        <li>
          <span class="font_20 weight_500">Make sure you have selected the correct search criteria</span>
        </li>
        <li>
          <span class="font_20 weight_500">Make sure that all words are spelled correctly</span>
        </li>
        <li>
          <span class="font_20 weight_500">Try different keywords</span>
        </li>
        <li>
          <span class="font_20 weight_500">Try more general keywords</span>
        </li>
      </ul>
    </div>
    <!-- Back to search button -->
    <!-- <button class="btn-back-to-search" (click)="goBackToSearch()">
      Back to Search
    </button> -->
  </div>
</ng-template>